import { BsPersonFill } from "react-icons/bs";
import "./ProfileImage.css";

interface Props {
  firstName?: string;
  lastName?: string;
  profileURL?: string | null;
  size?: "small" | "large";
}

export default function ProfileImage({
  firstName,
  lastName,
  profileURL,
  size = "small",
}: Props) {
  return (
    <div
      className={`profile-image ${
        size === "large" ? "profile-large" : "profile-small"
      }`}
    >
      {profileURL ? (
        <img
          src={profileURL}
          alt={profileURL}
          className={size === "large" ? "profile-large" : "profile-small"}
        />
      ) : firstName && lastName ? (
        firstName[0] + lastName[0]
      ) : (
        <BsPersonFill className="profile-icon" />
      )}
    </div>
  );
}
